module.exports = __webpack_public_path__ + "static/media/KMH_5411.9d9976a5.jpg";